import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";

/**
 *
 * @param {*} pxVal, pixels to transform to rem
 * @param {*} emSize, conversion factor. Accepted also with the "px" string
 */
export var px2rem = function px2rem(pxVal) {
  var emSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return "".concat(pxVal / _parseInt(emSize.toString().replace(/px/g, ''), 0), "rem");
};
export default {};